import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import { CommonRequest } from "@/types/http";
import { LaporanOperasi } from "@/types/laporan_operasi";

async function create(
  data: LaporanOperasi
): Promise<CommonRequest<LaporanOperasi>> {
  const response = await http.postData("/laporan-operasi", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function update(
  id: number,
  data: LaporanOperasi
): Promise<CommonRequest<LaporanOperasi>> {
  const response = await http
    .putData(`/laporan-operasi/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getByRegister(
  register_id: string | number
): Promise<CommonRequest<LaporanOperasi[]>> {
  const response = await http
    .getData(`/register/${register_id}/laporan-operasi`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getByRm(
  rm: string | number
): Promise<CommonRequest<LaporanOperasi[]>> {
  const response = await http
    .getData(`/pasien/${rm}/laporan-operasi`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function find(id: number): Promise<CommonRequest<LaporanOperasi>> {
  const response = await http.getData(`/laporan-operasi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function destroy(id: number): Promise<CommonRequest<undefined>> {
  const response = await http
    .deleteData(`/laporan-operasi/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function sign(id: number, data) {
  const response = await http
    .postData(`/laporan-operasi/${id}/signature`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

function print(id) {
  window.open(`${http.getAPI()}/laporan-operasi/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  getByRm,
  find,
  destroy,
  sign,
  print
};
